import React from 'react';
import { Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Sin estructura de sesión',
    cost: 'Improvisación que el paciente percibe'
  }, {
    without: 'Sin series por patología',
    cost: 'Cada sesión armada desde cero'
  }, {
    without: 'Sin protocolo de blindaje',
    cost: 'Absorción de la carga energética del paciente'
  }, {
    without: 'Sin planificación anual',
    cost: 'Trabajo reactivo sin visión estratégica'
  }, {
    without: 'Sin guiones de visualización',
    cost: 'Cierres de sesión sin profundidad terapéutica'
  }, {
    without: 'Sin Chi Kung adaptado',
    cost: 'Pacientes con movilidad reducida sin atención'
  }, {
    without: 'Sin protocolo de reseteo',
    cost: 'La carga de la jornada entra a tu casa cada noche'
  }, {
    without: 'Sin sistema sonoro',
    cost: 'Ambiente del consultorio sin intención terapéutica'
  }, {
    without: 'Sin ficha clínica',
    cost: 'Cada consulta sin registro ni continuidad real'
  }, {
    without: 'Sin el sistema',
    cost: 'El mismo ciclo de agotamiento e improvisación'
  }];
  return <Section data-id="element-17" data-mp="2pbcqkc2uj8rr">
      <div className="text-center mb-12" data-id="element-18" data-mp="2pbujayqav4ux">
        <h2 className="md:text-4xl font-display font-bold uppercase tracking-[0.12em] mb-4 text-[22px] text-brand-burgundy" data-id="element-19" data-mp="2bcle0u3mtv5q">
          ¿Cuánto cuesta no tenerlo?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-20" data-mp="2gdiwz8wgut8a">
        <div className="hidden md:block" data-id="element-21" data-mp="21mjt2b6kssv1">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-22" data-mp="21kp2ohcjc8jk">
            <div className="font-serif font-bold text-lg text-brand-purple" data-id="element-23" data-mp="26ejuk82anttq">
              Sin el Mega Pack
            </div>
            <div className="font-serif font-bold text-lg text-brand-burgundy" data-id="element-24" data-mp="1snyc2kgr5lwd">
              Consecuencia Real
            </div>
          </div>
          <div className="space-y-3" data-id="element-25" data-mp="1io7hkis6z6wa">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-brand-goldDark/15" data-id="element-26" data-mp="1iq0o7y2t1r4a" data-mpi={i}>
                <div className="text-sm font-medium text-brand-text pr-4" data-id="element-27" data-mp="14i5g9fo4436o">
                  {row.without}
                </div>
                <div className="text-sm text-brand-burgundy/90 font-medium" data-id="element-28" data-mp="zqnrdpzd5t22">
                  {row.cost}
                </div>
              </div>)}
          </div>
        </div>

        <div className="md:hidden space-y-4" data-id="element-29" data-mp="ptrgjdlzsuuc">
          {costs.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl border-brand-goldDark/15 space-y-2" data-id="element-30" data-mp="prerkghthk7s" data-mpi={i}>
              <p className="text-sm font-medium text-brand-text" data-id="element-31" data-mp="1nex84dhpzqmc">
                {row.without}
              </p>
              <div className="flex items-start space-x-2 text-brand-burgundy/90 font-medium" data-id="element-32" data-mp="1dj3knz2gqcps">
                <span className="text-brand-burgundy shrink-0" data-id="element-33" data-mp="18k0svgbhu2zr">→</span>
                <span className="text-sm" data-id="element-34" data-mp="18jr1boasvnry">{row.cost}</span>
              </div>
            </div>)}
        </div>
      </div>

      <div className="text-center mt-16" data-id="element-35" data-mp="21kebxtl5tn0">
        <p className="text-xl md:text-2xl font-serif italic font-[600] text-brand-burgundy" data-id="element-36" data-mp="3t9ygpa5789yd">
          "El terapeuta que tiene un sistema aplica con confianza. El que aplica
          con confianza genera resultados. El que genera resultados crece." 🌿
        </p>
      </div>
    </Section>;
};